import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";
import configureAxios from "@app/api/configureAxios";
import configureSentry from "./utils/configureSentry";
import configureMarkerIO from "./utils/configureMarkerIO";

import "./index.scss";

configureSentry();
configureAxios();
configureMarkerIO();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
